import styled from 'styled-components';

export const SellMinerContainer = styled.div`
    padding-inline: 15px;
`

export const SellCard = styled.div`
display: flex;
justify-content: space-evenly;
margin-block: 30px;
`

export const SellButton =  styled.button`
    margin-inline: auto;
    height: 40px;
    width: 25%;
`

export const MachineSellValueText = styled.div`
  color: ${({ theme }) => theme.colors.link.text};
`;